<!-- Footer -->
<footer class="page-footer font-small blue">
  <!-- Copyright -->
  <div class="footer-copyright text-center py-3">
    © {{ currentYear }} Copyright
    <a href="https://www.devgpt.absenceassistance.com" target="_blank">
      Absence Assistance</a
    >. All rights reserved
  </div>
  <!-- Copyright -->
</footer>
<!-- Footer -->
